import React, { memo, useMemo, useCallback } from 'react';
import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import CONFIG from './TableConfig';
import NewEntityList from 'containers/components/NewEntityList';
import { getLiteral } from 'utils/getLiteral';
import NoData from 'components/SvgIcons/emptyScreen/NoData';
import MarketingCampaigns from 'components/SvgIcons/emptyScreen/MarketingCampaigns';
import MarketingCampaignRow from './components/MarketingCampaignRow';

const Content = memo(() => {
    const tableParams = useMemo(() => {
        const newTableParams = {};

        return newTableParams;
    }, []);

    const config = useMemo(() => {
        return CONFIG(tableParams);
    }, [tableParams]);

    const emptyViewProps = useMemo(
        () => ({
            canCreate: true,
            icon: <NoData />,
            iconFirstTime: <MarketingCampaigns />,
            iconType: 'image',
            titleFirstTime: getLiteral('label_marketing_campaigns_reach_thousands_of_prospects'),
            subtitleFirstTime: getLiteral('label_marketing_campaigns_lets_start_first_campaign'),
            customButtonLiteral: 'action_marketing_campaigns_create_my_first_campaign',
        }),
        [],
    );

    const getRowNodeId = useCallback((data) => data.id, []);

    return (
        <div className="campaigns-table">
            {config && (
                <NewEntityList
                    id="fm-grid-campaigns-marketing"
                    entity={CAMPAIGNS_MARKETING}
                    config={config}
                    initOnReady={true}
                    useCache={true}
                    useSort={true}
                    useBackendSortWithoutLazyLoad={true}
                    useDragColumns={true}
                    getRowNodeId={getRowNodeId}
                    emptyViewProps={emptyViewProps}
                    useFullWidthDivider={true}
                    components={{ marketingCampaignRow: MarketingCampaignRow }}
                    rowHeight={72}
                    loaderPlaceholderRowHeight={72}
                />
            )}
        </div>
    );
});

export default Content;
